import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BenefitRulesService } from '../../../../../services/benefit-rules/benefit-rules.service';
import { Service } from '../../../../../models/benefit-rule.model';

@Component({
    selector: 'app-create-benefit-rule-modal',
    templateUrl: './create-benefit-rule-modal.component.html',
    styleUrls: ['./create-benefit-rule-modal.component.scss'],
    standalone: false
})
export class CreateBenefitRuleModalComponent implements OnInit {
  loading = false;
  loadingServices = false;
  services: Service[] = [];

  ruleForm = new FormGroup({
    benefit_service: new FormControl<string>('', [Validators.required]),
    trap_quantity: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    capacity: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    restaurant_count: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    description: new FormControl<string>('')
  });

  constructor(
    public activeModal: NgbActiveModal,
    private benefitRulesService: BenefitRulesService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadServices();
  }

  loadServices(): void {
    this.loadingServices = true;
    this.benefitRulesService.getServices().subscribe({
      next: (response) => {
        this.services = response.services || [];
        this.loadingServices = false;
      },
      error: (error) => {
        console.error('Error loading services:', error);
        this.toastr.error('Error loading services');
        this.loadingServices = false;
      }
    });
  }

  onSubmit(): void {
    if (this.ruleForm.invalid) {
      this.ruleForm.markAllAsTouched();
      this.toastr.warning('Please fill all required fields');
      return;
    }

    this.loading = true;
    const ruleData = this.ruleForm.value;
    
    this.benefitRulesService.createBenefitRule(ruleData as any).subscribe({
      next: (response) => {
        this.toastr.success(response.msg || 'Benefit rule created successfully');
        this.activeModal.close(true);
      },
      error: (error) => {
        console.error('Error creating benefit rule:', error);
        this.toastr.error(error?.error?.msg || 'Error creating benefit rule');
        this.loading = false;
      }
    });
  }

  close(): void {
    this.activeModal.dismiss(false);
  }

  // Getters for form controls
  get benefitServiceControl(): FormControl { return this.ruleForm.get('benefit_service') as FormControl; }
  get trapQuantityControl(): FormControl { return this.ruleForm.get('trap_quantity') as FormControl; }
  get capacityControl(): FormControl { return this.ruleForm.get('capacity') as FormControl; }
  get restaurantCountControl(): FormControl { return this.ruleForm.get('restaurant_count') as FormControl; }
  get descriptionControl(): FormControl { return this.ruleForm.get('description') as FormControl; }
}
